import { render, staticRenderFns } from "./commongroup.vue?vue&type=template&id=1525e22e&scoped=true&"
import script from "./commongroup.vue?vue&type=script&lang=js&"
export * from "./commongroup.vue?vue&type=script&lang=js&"
import style0 from "./commongroup.vue?vue&type=style&index=0&id=1525e22e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525e22e",
  null
  
)

export default component.exports